// Exterior
import exteriorCoastalImage from 'assets/img/homeownerApp/exterior/coastal.jpg';
import exteriorContemporaryImage from 'assets/img/homeownerApp/exterior/contemporary.jpg';
import exteriorCottageImage from 'assets/img/homeownerApp/exterior/cottage.jpg';
import exteriorCraftsmanImage from 'assets/img/homeownerApp/exterior/craftsman.jpg';
import exteriorFarmhouseImage from 'assets/img/homeownerApp/exterior/farmhouse.jpg';
import exteriorMediterraneanImage from 'assets/img/homeownerApp/exterior/mediterranean.jpg';
import exteriorMidCenturyModernImage from 'assets/img/homeownerApp/exterior/mid-century-modern.jpg';
import exteriorMonochromaticImage from 'assets/img/homeownerApp/exterior/monochromatic.jpg';
import exteriorRusticImage from 'assets/img/homeownerApp/exterior/rustic.jpg';
import exteriorTraditionalImage from 'assets/img/homeownerApp/exterior/traditional.jpg';
// Interior
import interiorCoastalImage from 'assets/img/homeownerApp/interior/coastal.jpg';
import interiorContemporaryImage from 'assets/img/homeownerApp/interior/contemporary.jpg';
import interiorCottageImage from 'assets/img/homeownerApp/interior/cottage.jpg';
import interiorCraftsmanImage from 'assets/img/homeownerApp/interior/craftsman.jpg';
import interiorFarmhouseImage from 'assets/img/homeownerApp/interior/farmhouse.jpg';
import interiorMediterraneanImage from 'assets/img/homeownerApp/interior/mediterranean.jpg';
import interiorMidCenturyModernImage from 'assets/img/homeownerApp/interior/mid-century-modern.jpg';
import interiorMonochromaticImage from 'assets/img/homeownerApp/interior/monochromatic.jpg';
import interiorRusticImage from 'assets/img/homeownerApp/interior/rustic.jpg';
import interiorTraditionalImage from 'assets/img/homeownerApp/interior/traditional.jpg';

export interface StyleSchema {
  name: string;
  interior: { background: string; image: string };
  exterior: { background: string; image: string };
}

export {
  exteriorCoastalImage,
  exteriorContemporaryImage,
  exteriorCottageImage,
  exteriorCraftsmanImage,
  exteriorFarmhouseImage,
  exteriorMediterraneanImage,
  exteriorMidCenturyModernImage,
  exteriorMonochromaticImage,
  exteriorRusticImage,
  exteriorTraditionalImage,
  interiorCoastalImage,
  interiorContemporaryImage,
  interiorCottageImage,
  interiorCraftsmanImage,
  interiorFarmhouseImage,
  interiorMediterraneanImage,
  interiorMidCenturyModernImage,
  interiorMonochromaticImage,
  interiorRusticImage,
  interiorTraditionalImage,
};

// NOTE: all style names must map to the "name" key for home.name.styles in i18n/en/homeownerApp.json
export const styles = [
  {
    name: 'monochromatic',
    exterior: {
      background: '#575652',
      image: exteriorMonochromaticImage,
    },
    interior: {
      background: '#73392C',
      image: interiorMonochromaticImage,
    },
  },
  {
    name: 'cottage',
    exterior: {
      background: '#746A61',
      image: exteriorCottageImage,
    },
    interior: {
      background: '#8C7B65',
      image: interiorCottageImage,
    },
  },
  {
    name: 'midCenturyModern',
    exterior: {
      background: '#353E4B',
      image: exteriorMidCenturyModernImage,
    },
    interior: {
      background: '#8C4C27',
      image: interiorMidCenturyModernImage,
    },
  },
  {
    name: 'contemporary',
    exterior: {
      background: '#636673',
      image: exteriorContemporaryImage,
    },
    interior: {
      background: '#8C6645',
      image: interiorContemporaryImage,
    },
  },
  {
    name: 'farmhouse',
    exterior: {
      background: '#826C5A',
      image: exteriorFarmhouseImage,
    },
    interior: {
      background: '#595845',
      image: interiorFarmhouseImage,
    },
  },
  {
    name: 'coastal',
    exterior: {
      background: '#686D6D',
      image: exteriorCoastalImage,
    },
    interior: {
      background: '#364959',
      image: interiorCoastalImage,
    },
  },
  {
    name: 'craftsman',
    exterior: {
      background: '#576B65',
      image: exteriorCraftsmanImage,
    },
    interior: {
      background: '#59573E',
      image: interiorCraftsmanImage,
    },
  },
  {
    name: 'traditional',
    exterior: {
      background: '#32354B',
      image: exteriorTraditionalImage,
    },
    interior: {
      background: '#565773',
      image: interiorTraditionalImage,
    },
  },
  {
    name: 'mediterranean',
    exterior: {
      background: '#9F5532',
      image: exteriorMediterraneanImage,
    },
    interior: {
      background: '#8C7558',
      image: interiorMediterraneanImage,
    },
  },
  {
    name: 'rustic',
    exterior: {
      background: '#677587',
      image: exteriorRusticImage,
    },
    interior: {
      background: '#593E2E',
      image: interiorRusticImage,
    },
  },
] as const satisfies readonly StyleSchema[];

export type Style = (typeof styles)[number];
